





























import Vue from 'vue'
import { Component, Emit } from 'vue-property-decorator'
import { ITenant } from '../types/types'
import { findUserTenantByEmail } from '../services/users'

import { debounce } from '../utils'

const emptyItem: ITenant = { tenantName: '' }
const selectedItem = ({ selected = false }: ITenant) => selected

function select(i: any, value: any) {
  i.selected = i === value
}

@Component
export default class Dropdown extends Vue {
  loading: boolean = false
  items: ITenant[] = []

  get selected(): ITenant {
    return this.items.find(selectedItem) || emptyItem
  }

  set selected(value: ITenant) {
    for (const i of this.items) {
      select(i, value)
    }
  }

  get decoredItem() {
    return this.selected.tenantName
  }

  debounceTyping(text: string) {
    debounce(400, this.typing)(text)
  }

  async typing(text: string) {
    try {
      if (!text) return false
      this.loading = true
      this.items = await findUserTenantByEmail(text)
    } catch (error) {
      this.$buefy.toast.open({
        message: 'Falha ao procurar contas',
        type: 'is-danger',
      })
    } finally {
      this.loading = false
    }
  }

  @Emit('selected')
  onSelectItem(item: ITenant = emptyItem) {
    this.selected = item
  }
}
